<template>
  <div class="form-error">
    <!-- <img src="@/assets/icons/error-cross.svg" alt="error-cross-ico" class="error-ico"> -->
    <p class="error-msg">{{message}}</p>
    <div class="clearfix"></div>
  </div>
</template>

<script>
export default {
  name: 'FormError',
  props: {
    message: {
      type: String,
      default: ''
    }
  },
}
</script>

<style lang="scss">
@import '~sass/modules/variables';

.form-error {
  background-color: $clr-bg-red;
  border: 1px solid $clr-border-red;
  border-radius: 4px;
  text-align: center;
  padding: 8px;
  .error-ico {
    float: left;
    width: 22px;
  }
  .error-msg{
    font-family: "ProximanovaRegular";	
    font-size: 14px;	
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Templates/FormError.vue